module.exports = __webpack_public_path__ + "img/angularLogo.84c42cef.png";